module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', [_vm._v(_vm._s(_vm.res))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b78ab994","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/view/status/index.vue
// module id = 2399
// module chunks = 1